module.exports = {
  BOH_TRANSACTIONS_EDIT_REQUEST: 'BOH_TRANSACTIONS_EDIT_REQUEST',
  BOH_TRANSACTIONS_EDIT_SUCCESS: 'BOH_TRANSACTIONS_EDIT_SUCCESS',
  BOH_TRANSACTIONS_EDIT_FAILURE: 'BOH_TRANSACTIONS_EDIT_FAILURE',
};
